<template>
  <van-collapse-item :title="org.orgName"
    :name="org.orgName">
    <template v-slot:title>
      <span class="org-name">{{org.orgName}}</span>
    </template>
    <template v-slot:value>
      <span>关联 <span style="color:#d04a02;">{{org.relationCount}}</span> 条PwC关系</span>
    </template>
    <contractor-item v-for="item in org.peContacts"
      v-bind:key="item.name"
      :data="item"
      :show-chk="isEdit"
      :show-prefer="showPrefer"
      :show-know="true"
      @cancel="cancelMark"
      :disable-swipe="disableSwipe">
    </contractor-item>
  </van-collapse-item>
</template>

<script>
import {
  Dialog
} from 'vant';
import ContractorItem from "./ContractorItem";

export default {
  data () {
    return {
      showPrefer: true,
      isEdit: false,
      disableSwipe: true
    };
  },
  props: {
    org: {
      type: Object,
      required: true,
    }
  },
  components: { ContractorItem },
  computed: {},
  mounted () { },
  methods: {
    cancelMark (id) {
      common.cancelMark(this, id);
    },
  },
};
</script>

<style lang='scss' scoped>
.org-name {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/contractor/ContractorGroupListItem.vue